import { StyleSheet } from 'react-native';
import colors from '../../colors';
import * as Colors from "../../../../tools/Colors";
import {moderateScale} from "../../../../tools/Scaling";

export const HEIGHT = moderateScale(60);

export default StyleSheet.create({
  base: {
    flexDirection: 'row',
    //height: HEIGHT,
    width: '90%',
    borderRadius: moderateScale(6),
    backgroundColor: Colors.white,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.1,
    shadowRadius: moderateScale(6),
    elevation: 2
  },
  borderLeft: {
    borderLeftWidth: moderateScale(5),
    borderLeftColor: colors.alto
  },
  leadingIconContainer: {
    width: moderateScale(50),
    justifyContent: 'center',
    alignItems: 'center'
  },
  contentContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-start' // in case of rtl the text will start from the right
  },
  trailingIconContainer: {
    width: moderateScale(40),
    justifyContent: 'center',
    alignItems: 'center'
  },
  leadingIcon: {
    width: moderateScale(20),
    height: moderateScale(20)
  },
  trailingIcon: {
    width: moderateScale(9),
    height: moderateScale(9)
  },
  text1: {
    fontSize: moderateScale(14),
    fontWeight: 'bold',
    marginBottom: moderateScale(3)
  },
  text2: {
    fontSize: moderateScale(12),
    color: colors.dustyGray
  }
});
